import React, { Component } from 'react';
import { config } from "../libs/utils/Const";
import { connect } from "react-redux";
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';

class CommentsModal extends Component {

    componentDidMount(): void {
        this.closeAction();
    }

    closeConfirm = async () => {
        $('#commentsModal').modal('hide');
    }

    closeAction = () => {
        $('#commentsModal').on('hidden.bs.modal', function () {
        });
    };
    setUserFields = () => {
        const { userFields, updateFields, notificationReducer: { showAlert } } = this.props
        let validFields = true
        for (let index = 0; index < userFields.length; index++) {
            const field = userFields[index];
            const fieldValue = document.getElementById(field.field)?.value || '';
            if ((!fieldValue || fieldValue == '') && field.requiredField) {
                validFields = false
                showAlert({ type: 'error', message: `Campo ${field.fieldName} es obligatorio` });
                break;
            }
            field.selection = fieldValue
        }
        updateFields(userFields)
        return validFields
    }

    Continue = () => {
        const { notificationReducer: { showAlert }, sendOrder, sendOrderVta, tipo } = this.props;
        let comment = document.getElementById("comments").value;
        if (comment.length <= 20) {
            if (tipo === 1) {
                sendOrder(comment);
                $('#commentsModal').modal('hide');
            }
            else {
                if (this.setUserFields()) {
                    sendOrderVta(comment);
                    $('#commentsModal').modal('hide');
                }
            }
        }
        else {
            showAlert({ type: 'error', message: 'Has excedido más de 20 caracteres.' });
            return;
        }
    }

    render() {
        const { userFields, tipo } = this.props
        return (
            <div class="modal" tabindex="-1" role="dialog" id="commentsModal" >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">

                        <div class="modal-header text-light" style={{ background: '#2d75bd', borderRadius: '0' }}>
                            <h5 class="modal-title">Escribe aqui tu comentario.</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">

                            <div className="row">
                                {tipo == 2 &&
                                    <div className="col-sm-12 col-md-12">
                                        {userFields && userFields.map((field) => (
                                            <div className="form-group" style={{ marginBottom: '2px' }} key={field.field}>

                                                <label htmlFor={field.field} style={{ fontWeight: 'bold' }}>
                                                    {field.fieldName}
                                                </label>

                                                <select className="form-control" id={field.field}>
                                                    <option value="">-- Selecciona --</option>
                                                    {field.Options && field.Options.map(opt => (
                                                        <option key={opt.Code} value={opt.Code}>
                                                            {opt.Name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        ))}
                                    </div>
                                }

                                <div className="col-sm-12 col-md-12 mt-2">
                                    <div class="form-group" style={{ marginBottom: '2px' }}>
                                        <label htmlFor="comments" style={{ fontWeight: 'bold' }}>
                                            Comentarios
                                        </label>
                                        <input type="text" class="form-control" autoComplete="off" id="comments" placeholder="Escribe aqui" maxLength={20} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" className="btn btn-danger" onClick={this.closeConfirm}>Cerrar</button>
                            <button type="button" className="btn btn-success" onClick={this.Continue}> Crear </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

export default connect(
    mapStateToProps,
)(CommentsModal);



//export default ;